import {inject, Injectable, signal} from "@angular/core";
import {IAlertCommentController, MK_ALERT_COMMENT} from "./IAlertCommentController";
import {AbstractController} from "../../../controllers/AbstractController";
import {UserSessionRepository} from "../../../repositories/user-session.repository";
import {AlertCommentRepository} from "../../../repositories/alert-comment.repository";
import {CustomDatesService} from "../../../services/custom-dates.service";
import {AlertComment} from "../../../interfaces/rest/AlertComment";
import {Helper} from "../../../helpers/Helper";

@Injectable()
export class AlertCommentController extends AbstractController implements IAlertCommentController {

  private readonly userSessionRepository: UserSessionRepository;
  private readonly alertCommentRepository: AlertCommentRepository;
  private readonly customDatesService: CustomDatesService;

  readonly currentUserId: number = 0;
  readonly currentUserEmail: string = '';
  private commentMessage = '';
  private errorMessage: string = '';

  constructor() {
    super();

    this.userSessionRepository = inject(UserSessionRepository);
    this.alertCommentRepository = inject(AlertCommentRepository);
    this.customDatesService = inject(CustomDatesService);
    this.currentUserId = this.userSessionRepository.getUserSession()?.userId!;
    this.currentUserEmail = this.userSessionRepository.getUserSession()?.email!;
    this.addModel(MK_ALERT_COMMENT, {
      currentUserEmail$: signal(this.currentUserEmail),
      commentsList$: signal([]),
      newComment$: signal(null),
      alertInstanceId$: signal(null),
      alertRuleId$: signal(null),
      currentUserId$: signal(this.currentUserId)
    });
  }

  handlePostComment(newComment: any): void {
    let message = newComment;
    let model = this.getModel(MK_ALERT_COMMENT);
    let existingComments = model.commentsList$();

    const comment = new AlertComment();
    comment.comments = Helper.removeScriptTagIfPresent(message);
    comment.alertInstanceId = Number(model.alertInstanceId$()!);
    comment.alertRuleId = model.alertRuleId$()!;
    comment.userId = Number(model.currentUserId$());
    comment.userEmail = model.currentUserEmail$();

    this.alertCommentRepository.saveAlertComment(comment).subscribe((result: any) => {
      if(result) {
        result.__displayTimestamp = this.customDatesService.convertMillisToUserFormat(result.commentTimestamp);
        existingComments = existingComments.concat(result);
        model.commentsList$?.set(existingComments);
      }
    });
  }
}
